<script>
import Layout from '@layouts/main'

export default {
  page: {
    title: 'Loading page...',
    meta: [{ name: 'description', content: 'Loading page...' }],
  },
  components: { Layout },
}
</script>

<template>
  <Layout>
    <Transition appear>
      <!-- <BaseIcon :class="$style.loadingIcon" name="sync" spin /> -->
      <div class="text-center">
        <b-spinner
          style="width: 4rem; height: 4rem;"
          variant="primary"
          label="Text Centered"
        ></b-spinner>
      </div>
    </Transition>
  </Layout>
</template>

<style lang="scss" module>
.loadingIcon {
  display: block;
  margin: 0 auto;

  // stylelint-disable-next-line selector-class-pattern
  &:global(.v-enter-active) {
    transition: opacity 1s;
  }
  // stylelint-disable-next-line selector-class-pattern
  &:global(.v-enter) {
    opacity: 0;
  }
}
</style>
